import { Component, Input } from '@angular/core';
import { Image } from './../../../../../atoms/image-with-label/models/image.interface';

/**
 * This component is responsible to create a image tag with
 * visiblity configuration and custom styling attributes.
 */
@Component({
  selector: 'idp-banner-image',
  templateUrl: './banner-image.component.html',
  styleUrls: ['./banner-image.component.scss']
})
export class BannerImageComponent {
  @Input() content: Image = {} as Image;
}
